<adapt-menu [items]="systemMenu"
            [disabled]="disabled"
            data-test="system-add-menu"></adapt-menu>
